import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  showNotification as showNotificationAction,
  translate as t,
  Restricted,
} from 'admin-on-rest';

import { crudGetMatching as onCrudGetMatching } from 'admin-on-rest/lib/actions/dataActions';

import { get } from 'lodash';

import Card from 'material-ui/Card';
import CardText from 'material-ui/Card/CardText';

const Organisation = (props) => (
  <Restricted authParams={{ route: '/organisation' }} location={props.location}>
    <div>
      <Card>
        <CardText>
          <h1>{props.translate('organisation-moved-title')}</h1>{' '}
          <p style={{ fontSize: '1.1rem', fontWeight: 'bold' }}>
            <a href="https://restaurant.pinchos.se/organisation">
              {props.translate('organisation-moved-text')}
            </a>
          </p>
        </CardText>
      </Card>
    </div>
  </Restricted>
);

export default connect(
  (state) => ({
    ...state,
    user: get(state, 'auth.user'),
    venueId: get(state, 'auth.user.defaultVenue') || 'se-gbg-heden',
    manager: get(state, 'auth.permissions.organisationManager'),
  }),
  (dispatch) => ({
    showNotification: showNotificationAction,
    crudGetMatching: onCrudGetMatching,
    dispatch,
  })
)(withRouter(t(Organisation)));
